import { useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  tokenExpired,
  loginSessionAvailable,
} from "../features/auth/authSlice";
import { jwtDecode } from "jwt-decode";

export const useTokenValidation = () => {
  const dispatch = useDispatch();
  const { isAuthenticated, token } = useSelector((state) => state.auth);

  const validateToken = useCallback(() => {
    const storedToken = localStorage.getItem("token_bearer");

    if (!storedToken) {
      dispatch(tokenExpired());
      return false;
    }

    try {
      const decoded = jwtDecode(storedToken);
      const currentTime = Date.now() / 1000;

      if (decoded.exp && decoded.exp < currentTime) {
        dispatch(tokenExpired());
        return false;
      }

      return true;
    } catch (error) {
      dispatch(tokenExpired());
      return false;
    }
  }, [dispatch]);

  // Check token validity on mount and when token changes
  useEffect(() => {
    if (isAuthenticated) {
      validateToken();
    }
  }, [isAuthenticated, token, validateToken]);

  // Set up interval to check token expiration every minute
  useEffect(() => {
    if (isAuthenticated) {
      const interval = setInterval(() => {
        validateToken();
      }, 60000); // Check every minute

      return () => clearInterval(interval);
    }
  }, [isAuthenticated, validateToken]);

  return { validateToken };
};
